import { Button } from "./Button"
import * as Icones from "./Icones"
import { cn } from "../lib/cn"

export function FiltroAplicado({
  rotulo,
  valor,
  aoLimpar,
  compacto = false,
}: {
  rotulo: string
  valor: string
  aoLimpar: () => void
  compacto?: boolean
}) {
  const dica = `Tirar o filtro de ${rotulo.toLowerCase()}`
  return (
    <span
      data-slot="filtro-aplicado"
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md border border-(--borda-forte) bg-(--painel-alt) pr-1",
        compacto ? "h-7 pl-2.5 text-xs" : "h-10 pl-3 text-sm",
      )}
    >
      <span className="text-(--tinta-2)">{rotulo}:</span>
      <strong className="font-semibold text-(--tinta)">{valor}</strong>
      <Button type="button" variant="ghost" size={compacto ? "icon-xs" : "icon-sm"} aria-label={dica} title={dica} onClick={aoLimpar}>
        <Icones.Fechar />
      </Button>
    </span>
  )
}
